import * as React from "react";
import { cn } from "../../lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-9 w-full rounded-[var(--sc-radius-md)] border border-[var(--sc-border)] bg-[var(--sc-surface)] px-3 py-2 text-sm text-[var(--sc-text)]",
          "placeholder:text-[var(--sc-muted)]",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--sc-amber)] focus-visible:ring-offset-0 focus-visible:border-[var(--sc-amber)]",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "transition-colors",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
